import Api from '@/services/Api'

export default {
  getTomaxZones (token) {
    return Api().get('tomaxzones')
  },

  addTomaxZone (params) {
    return Api().post('tomaxzones', params)
  },

  updateTomaxZone (params) {
    return Api().put('tomaxzone/' + params._id, params)
  },

  deleteTomaxZone (id) {
    return Api().delete('tomaxzone/' + id)
  },

  getSingleTomaxZone (_id) {
    return Api().get('tomaxzone/' + _id)
  }
}



// WEBPACK FOOTER //
// ./src/services/TomaxZoneService.js